function applyHybridGuardBadge() {
// There are TWO li.tmenu_open-default elements: one mobile, one desktop.
// Loop all of them so each gets a badge independently.
const containers = document.querySelectorAll('li.tmenu_open-default');

containers.forEach(function(container) {
for (const body of container.querySelectorAll('.tmenu_product_body')) {
    const title = body.querySelector('.tmenu_product_title');
    if (title && title.textContent.trim() === 'Hybrid Guard') {
    if (!body.querySelector('.js-best-seller-badge')) {
        const badge = document.createElement('div');
        badge.className = 'js-best-seller-badge';
        badge.textContent = 'BEST SELLER';
        body.appendChild(badge);
    }
    break;
    }
}
});
}

// Mobile: re-run when drawer opens (in case it re-renders)
document.querySelector('.js-drawer-open-nav')?.addEventListener('click', () => {
setTimeout(applyHybridGuardBadge, 100);
});

// Both menus are in the DOM on load — run after Qikify initialises
window.addEventListener('load', () => {
setTimeout(applyHybridGuardBadge, 1000);
});
// Qikify only initialises its desktop menu when the page loads at desktop
// width, so reload once if the viewport crosses into desktop. (Moved here from
// an inline script in layout/theme.liquid.)
(function () {
  var mq = window.matchMedia('(min-width: 768px)');
  mq.addEventListener('change', function (e) {
    if (e.matches) window.location.reload();
  });
})();
